export default function (o) {
  Object.assign(o, {

    sendContactUsMessage (message) { return this.server.post('contact-us', message) },

    sendCustomRfpMessage (message) { return this.server.post('custom-rfp-message', message) }

  })
}
